<!-- Banner Background -->
<!-- [style.background-image]="'url(' + slidesData[0]?.bannerUrl + ')'" -->
<!-- [style.background-image]="slidesData[0]?.bannerUrl ? 'url(' + slidesData[0].bannerUrl + ')' : 'none'" -->
<section [style.background-image]="
    slidesData[0]?.bannerUrl
      ? 'linear-gradient(180deg, rgba(0, 0, 0, 0.6) 0%, rgba(48, 97, 226, 0.6) 200%), url(' +
        slidesData[0].bannerUrl +
        ')'
      : 'linear-gradient(180deg, rgba(0, 0, 0, 0.6) 0%, rgba(48, 97, 226, 0.6) 200%)'
  " style="
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  " class="header-filter home-banner text-center">
  <div class="container header">
    <div class="row py-lg-5">
      <div class="col-lg-8 col-md-8 mx-auto position-relative">
        <!-- Weekly Banner with top space -->

        <!-- <a *ngIf="!user || !user.isSubscribed" routerLink="/pricing">
          <div class="weekly-update-banner-container">
            <div class="weekly-update-banner">

              <span class="weekly-text text-white">
                Limited Time Offer</span>
              <span class="badge-new">Up to 80% OFF</span>
            </div>
          </div>
        </a> -->

        <!-- <div class="weekly-update-banner-container">
          <div class="weekly-update-banner">
            <span class="badge-new">New</span>
            <span class="weekly-text text-white"
              >illustrations every week!</span
            >
          </div>
        </div> -->

        <h1 class="fs-2 text-white fw-semi">
          Illustrations for everything you design
        </h1>

        <p class="text-white lead mb-4">
          Discover, customize, and download beautiful illustrations for websites, apps, presentations, and more.
        </p>
        <form class="col-lg-10 mx-auto d-flex search-form">
          <!-- show-mobile-view-search -->
          <div class="show-small-screen-search input-group input-group-lg">
            <input type="search" class="ellipsis ft-size boxz ds-input form-control" [placeholder]="
                searchKey == 'Illustration'
                  ? 'Search for illustrations'
                  : searchKey == 'Collections'
                  ? 'Search for Collections'
                  : searchKey == 'AI Images'
                  ? 'Search for AI Images'
                  : ''
              " [formControl]="typeahead" (input)="suggest()" (keyup.enter)="navigateTo()" />
            <a [routerLink]="['/search/']" [queryParams]="{
                value: typeahead.value,
                searchKey: searchKey,
                cate: searchKey == 'AI Images' ? 'ai' : ''
              }" [class]="
                typeahead.value
                  ? 'btn btn-ib-light'
                  : 'btn btn-ib-light disable'
              " [class.disable]="!typeahead.value" [attr.aria-disabled]="!typeahead.value" aria-label="Search">
              <i class="fas fa-search" aria-hidden="true"></i>
            </a>
          </div>

          <!-- show-desktop-view-search -->
          <div class="show-lg-screen-search input-group input-group-lg dropdown position-relative">
            <button class="ft-size boxz btn res-btn border dropdown-toggle" type="button" data-bs-toggle="dropdown"
              aria-expanded="false">
              <i [ngClass]="{
                  'fas fa-image': searchKey === 'illus ',
                  'fas fa-layer-group': searchKey === 'collect'
                }"></i>

              <span class="d-none d-md-inline">{{ searchKey }}</span>
            </button>

            <ul class="dropdown-menu shadow mb-5 bg-body rounded-3 ps-2 pe-2" aria-labelledby="dropdownMenuLink">
              <li>
                <a class="dropdown-item rounded-2" href="#" (click)="setSearchKey('illus')">Illustration</a>
              </li>
              <li>
                <a class="dropdown-item rounded-2" href="#" (click)="setSearchKey('collect')">Collections</a>
              </li>
              <li>
                <a class="dropdown-item rounded-2" href="#" (click)="setSearchKey('aiImage')">AI Images</a>
              </li>
            </ul>

            <label for="searchInput" class="visually-hidden">
              Search
            </label>

            <input type="search" class="ellipsis ft-size boxz ds-input form-control" [placeholder]="
                searchKey == 'Illustration'
                  ? 'Search for illustrations'
                  : searchKey == 'Collections'
                  ? 'Search for Collections'
                  : searchKey == 'AI Images'
                  ? 'Search for AI Images'
                  : ''
              " [formControl]="typeahead" (input)="suggest()" (keyup.enter)="navigateTo()" />
            <a [routerLink]="['/search/']" [queryParams]="{
                value: typeahead.value,
                searchKey: searchKey,
                type: searchKey == 'AI Images' ? 'ai' : ''
              }" [class]="
                typeahead.value
                  ? 'btn btn-ib-light'
                  : 'btn btn-ib-light disable'
              " [class.disable]="!typeahead.value" [attr.aria-disabled]="!typeahead.value" aria-label="Search">
              <i class="fas fa-search" aria-hidden="true"></i>
            </a>
          </div>

          <div #autoSuggestion class="suggestions" [style.display]="
              suggestions?.length > 0 || typeahead?.value?.length > 0
                ? 'block'
                : 'none'
            " *ngIf="suggestions?.length > 0 || typeahead?.value?.length > 0">
            <span class="overflow-text" *ngIf="searchKey == 'Illustration'">
              <a (click)="onSuggestionClick()" class="overflow-text" *ngFor="let s of suggestions"
                routerLink="/illustration/{{ s.slug }}">
                <img [src]="getSEOImage(s.previewUrl || s.jpeg || s.png)" alt="{{ s.title }}"
                  class="skeleton--thumbnial" />
                {{ s.title }}
              </a></span>
            <span *ngIf="searchKey == 'Collections'">
              <a class="overflow-text" (click)="onSuggestionClick()" *ngFor="let s of suggestions"
                routerLink="/illustration-collection/{{ s.slug }}">
                <img [src]="getSEOImage(s.thumbUrl)" alt="{{ s.collectionName }}" class="skeleton--thumbnial" />
                {{ s.collectionName }}
              </a></span>
            <span *ngIf="searchKey == 'AI Images'">
              <a class="overflow-text" (click)="onSuggestionClick()" *ngFor="let s of suggestions"
                routerLink="/ai-image/{{ s.slug }}">
                <img [src]="getSEOImage(s.previewUrl || s.jpeg || s.png)" alt="{{ s.title }}"
                  class="skeleton--thumbnial responsive-thumbnail" />
                {{ s.title }}
              </a></span>
            <span *ngIf="
                suggestions &&
                suggestions?.length == 0 &&
                typeahead &&
                typeahead?.value?.length > 0
              " [style.display]="
                suggestions &&
                suggestions.length == 0 &&
                typeahead &&
                typeahead.value.length > 0
                  ? 'block'
                  : 'none'
              ">
              <a>No data found</a>
            </span>
          </div>
        </form>

        <!-- Skeleton -->
        <div *ngIf="chiploading" class="suggestion-tags d-flex flex-wrap justify-content-center gap-2 mt-3">
          <div class="chip-skeleton" *ngFor="let i of [1,2,3,4,5,6]"></div>
        </div>

        <!-- Real Chips -->
        <div *ngIf="!chiploading" class="suggestion-tags d-flex flex-wrap justify-content-center gap-2 mt-3">

          <a *ngFor="let cate of cateData" data-bs-dismiss="offcanvas" data-bs-target="#bdNavbar"
            class="suggestion-chip" [routerLink]="['/search/']" [queryParams]="{
                    cate: cate.categoryName,
                    searchKey: searchkey
                  }">{{ cate.categoryName }}</a>
        </div>

      </div>
    </div>
  </div>
</section>

<!-- <div *ngIf="!user" class="banner-signup">
  <div class="container">
    <div class="d-flex align-items-center justify-content-center">
      <p class="me-3 banner-signup-font-size">
        Start free with 3 daily downloads or Go Pro for unlimited access.
      </p>

      <div class="d-flex gap-2">
        <a
        style="white-space: nowrap"
        routerLink="/pricing"
        class="btn btn-ib-primary rounded-3"
        >Go Pro</a>
      
      <a
        style="white-space: nowrap"
        routerLink="/signup"
        class="btn btn-outline-black rounded-3"
        >Sign up for free</a>
      </div>
    </div>
  </div>
</div> -->

<div *ngIf="!user" class="banner-signup py-3">
  <div class="container">
    <div class="row align-items-center justify-content-center text-center text-md-start">
      <div class="col-12 col-md-auto mb-2 mb-md-0">
        <p class="banner-signup-font-size mb-0">
          Start free with 3 daily downloads or Go Pro for unlimited access.
        </p>
      </div>
      <div class="col-12 col-md-auto">
        <div class="d-flex flex-column flex-md-row justify-content-center gap-2">
          <a style="white-space: nowrap" routerLink="/pricing" class="btn btn-ib-primary rounded-3">Go Pro</a>
          <a style="white-space: nowrap" routerLink="/signup" class="btn btn-outline-black rounded-3">Sign up for
            free</a>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <section *ngIf="exclusiveData.length > 0">
  <div class="py-4 container">
    <div class="row">
      <div class="d-sm-flex justify-content-sm-between">
        <h2 class="fs-4 fw-bold">Exclusive Collections</h2>
        <div class="browse-all" *ngIf="exclusiveData.length > 5">
          <a routerLink="/exclusive-collections" class="btn btn-outline-dark"
            >Browse All</a
          >
        </div>
      </div>
    </div>

    <div class="row row-cols-lg-5 py-3">
      <div
        class="col-md-4 col-sm-6 col-6 mb-4"
        *ngFor="let data of exclusiveData"
      >
        <figure class="skeleton--image position-relative">
          <a
            *ngIf="data.thumbUrl"
            [routerLink]="'/illustration-collection/' + data.slug"
          >
            <div class="card collection-radius">
              <img
                [src]="data.thumbUrl"
                class="img-fluid rounded-top skeleton--image"
                [alt]="data.collectionName"
                (load)="data.loader = true"
              />
              <div class="card-body border-top">
                <ng-container *ngIf="data.loader; else skeletonText">
                  <p class="overflow-text fw-semi text-dark card-text">
                    {{ data.collectionName }}
                  </p>
                </ng-container>

                <ng-template #skeletonText>
                  <p class="skeleton--text short mb-0"></p>
                </ng-template>
              </div>
            </div>
          </a>
        </figure>
      </div>
      <div
        class="col-md-12 col-sm-12 col-lg-12 mb-2 text-center"
        *ngIf="exclusiveData.length === 0 && !loader"
      >
        <div class="container">
          <img
            style="height: 200px"
            class="img-fluid mb-3"
            src="assets/img/no-data-found.svg"
            alt="No Data Found"
          />
          <h1 class="fw-bold fs-4 text-dark mb-2">
            Illustration not available
          </h1>
          <p class="mb-4 text-dark">
            We couldn't load the illustration at the moment.
          </p>
          <a href="/" class="btn btn-ib-primary rounded-3 fw-semi">Retry</a>
        </div>
      </div>
    </div>
  </div>
</section> -->
<!-- 
<section class="py-4">
  <div class="container overflow-hidden">
    <div class="row">
      <div class="d-gird gap-2 d-sm-flex justify-content-sm-between mb-4">
        <h2 class="my-auto hide-sm hide-mb-sm-3 fs-4 fw-bold">
          Explore Illustrations
        </h2>

        <div class="d-flex justify-content-center recent-popular-tabs">
          <ul class="nav nav-pills" id="pills-tab" role="tablist">
            <li class="nav-item" role="presentation">
              <button class="nav-link rounded-3 active fw-bold" id="pills-recent-tab" data-bs-toggle="pill"
                data-bs-target="#pills-recent" type="button" role="tab" aria-controls="pills-recent"
                aria-selected="true">
                Recent
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link fw-smei rounded-3" id="pills-popular-tab" data-bs-toggle="pill"
                data-bs-target="#pills-popular" type="button" role="tab" aria-controls="pills-popular"
                aria-selected="false">
                Popular
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="recent-popular-contents">
      <div class="tab-content" id="pills-tabContent">
        Recent Illustrations
        <div class="tab-pane fade show active" id="pills-recent" role="tabpanel" aria-labelledby="pills-recent-tab">
          <div class="row row-cols-lg-4">
            <div class="col-md-4 col-sm-6 col-6 mb-2" *ngFor="let data of visibleIllusData">
              <figure class="skeleton--image position-relative">
                <div class="position-absolute mt-2 ms-2" *ngIf="data.isPremium">
                  <span class="badge rounded cursor text-bg-dark">Pro</span>
                </div>
                <a *ngIf="getSEOImage(data?.previewUrl || data.jpeg || data.png)"
                  [routerLink]="'/illustration/' + data.slug">
                  data?.previewUrl || data.jpeg || data.png
                  getSEOImage(data?.previewUrl || data.jpeg || data.png)
                  <img [src]="getSEOImage(data?.previewUrl || data.jpeg || data.png)" [alt]="data.title"
                    class="img-radius img-fluid" [class.skeleton--image]="!data.imageLoad"
                    [class.image-loaded]="data.imageLoad" (load)="data.imageLoad = true" />

                  <figcaption class="hide-caption figure-caption">
                    <p>{{ data.title }}</p>
                  </figcaption>
                </a>
              </figure>
            </div>

            <div class="col-md-12 col-sm-12 col-lg-12 mb-2 text-center" *ngIf="!loader && visibleIllusData.length === 0">
              <div class="container">
                <img style="height: 200px" class="img-fluid mb-3" src="assets/img/no-data-found.svg"
                  alt="No Data Found" />
                <h1 class="fw-bold fs-4 text-dark mb-2">
                  Illustration not available
                </h1>
                <p class="mb-4 text-dark">
                  We couldn't load the illustration at the moment.
                </p>
                <a href="/" class="btn btn-ib-primary rounded-3 fw-semi">Retry</a>
              </div>
            </div>
          </div>

          🔹 Load More Row (SEPARATE ROW)
          <div class="row my-4" *ngIf="!loader && hasMoreIllus">
            <div class="col-12 d-flex justify-content-center">

              <button class="btn fw-semi btn-outline-black rounded-3 px-4 py-2
                      d-flex align-items-center gap-2" (click)="loadMoreIllus()" [disabled]="isLoadingMore">

                <span *ngIf="isLoadingMore" class="spinner-border spinner-border-sm"></span>

                <span>{{ isLoadingMore ? 'Loading...' : 'Load more' }}</span>

              </button>

            </div>
          </div>

        </div>

        Populor Illustrations
        <div class="tab-pane fade" id="pills-popular" role="tabpanel" aria-labelledby="pills-popular-tab">
          <div class="row row-cols-lg-4">
            <div class="col-md-4 col-sm-6 col-6 mb-2" *ngFor="let data of visiblePopularData">
              <figure class="skeleton--image position-relative">
                <div class="position-absolute mt-2 ms-2" *ngIf="data.isPremium">
                  <span class="badge rounded cursor text-bg-dark">Pro</span>
                </div>
                <a *ngIf="getSEOImage(data?.previewUrl || data.jpeg || data.png)"
                  routerLink="/illustration/{{ data.slug }}">
                  <img [src]="getSEOImage(data?.previewUrl || data.jpeg || data.png)" [alt]="data.title"
                    class="img-radius img-fluid" [class.skeleton--image]="!data.imageLoad"
                    (load)="data.imageLoad = true" />

                  <figcaption class="hide-caption figure-caption">
                    <p>{{ data.title }}</p>
                  </figcaption>
                </a>
              </figure>
            </div>

            <div class="col-md-12 col-sm-12 col-lg-12 mb-2 text-center"
              *ngIf="!loader && visiblePopularData.length === 0">
              <div class="container">
                <img style="height: 200px" class="img-fluid mb-3" src="assets/img/no-data-found.svg"
                  alt="No Data Found" />
                <h1 class="fw-bold fs-4 text-dark mb-2">
                  Illustration not available
                </h1>
                <p class="mb-4 text-dark">
                  We couldn't load the illustration at the moment.
                </p>
                <a href="/" class="btn btn-ib-primary rounded-3 fw-semi">Retry</a>
              </div>
            </div>
          </div>

                      🔹 Load More Row (SEPARATE ROW)
            <div class="row my-4" *ngIf="!loader && hasMorePopular">
              <div class="col-12 d-flex justify-content-center">

                <button class="btn fw-semi btn-outline-black rounded-3 px-4 py-2
                      d-flex align-items-center gap-2" (click)="loadMorePopular()" [disabled]="isPopularLoadingMore">

                  <span *ngIf="isPopularLoadingMore" class="spinner-border spinner-border-sm"></span>

                  <span>{{ isPopularLoadingMore ? 'Loading...' : 'Load more' }}</span>

                </button>

              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</section> -->


<section class="workflow-section">

  <div class="container workflow-container">

    <!-- =========================
         HEADER
    ========================== -->

    <div class="workflow-header-row d-flex justify-content-between align-items-end">

      <div class="workflow-heading">

        <h2 class="workflow-title">
          Find the right illustration <br>
          Faster
        </h2>

        <p class="workflow-description text-secondary">
         From discovery to download, Illusbook makes it simple to find visuals that fit your next project.
        </p>

      </div>

      <a routerLink="illustration-collection/business-illustrations" class="workflow-cta">
        Start exploring
        <span>→</span>
      </a>

    </div>


    <!-- =========================
         CARDS
    ========================== -->

    <div class="workflow-grid">

      <div class="row g-3">


        <!-- =========================
             LEFT CARD
        ========================== -->

        <div class="col-lg-4">

          <div class="workflow-card workflow-card-left">

            <h3>
              Discover illustrations
            </h3>

            <p>
              Explore a growing library of illustrations across styles, categories, and themes. Find inspiration or start with exactly whay you need.
            </p>


            <!-- Fake UI -->
            <div class="tools-interface">

              <div class="tools-tabs">

                <span class="tools-tab active">
                  All
                </span>

                <span class="tools-tab text-secondary">
                  Business
                </span>

                <span class="tools-tab text-secondary">
                  People
                </span>

                <span class="tools-tab text-secondary">
                  Technology
                </span>

              </div>


              <div class="tools-image-grid">

                <a routerLink="illustration-collection/christmas-illustrations">
                  <div class="tool-image large tool-image-1">
                  <span class="tool-label">
                    Christmas
                  </span>
                </div>
                </a>

                <a routerLink="illustration-collection/education-illustrations">
                  <div class="tool-image large tool-image-2">
                  <span class="tool-label">
                    Online Learning
                  </span>
                </div>
                </a>

                <a routerLink="illustration-collection/technology-illustrations">
                  <div class="tool-image tool-image-3">
                  <span class="tool-label">
                     Ciber security
                  </span>
                </div>
                </a>

                <a routerLink="illustration-collection/people-illustrations">
                  <div class="tool-image tool-image-4">
                  <span class="tool-label">
                   listening music
                  </span>
                </div>
                </a>

              </div>

            </div>

          </div>

        </div>


        <!-- =========================
             RIGHT SIDE
        ========================== -->

        <div class="col-lg-8">

          <div class="row g-3">


            <!-- =========================
                 WIDE BLACK CARD
            ========================== -->

            <div class="col-12">

              <div class="workflow-card workflow-card-wide">

                <h3>
                  Search by idea
                </h3>

                <p>
                Search for what you're looking for and quickly discover illustrations that match your project.
                </p>


                <div class="node-visual">

                  <img
                    class="node-image one"
                    src="https://img.illusbook.com/collection/A-boy-kicking-the-football-in-a-ground-illustration.jpg"
                    alt="people illustration"
                  >

                  <img
                    class="node-image two"
                    src="https://img.illusbook.com/collection/A-boy-studying-with-the-laptop-concept-illustration.jpg"
                    alt="education illustration"
                  >

                  <div class="node-line one"></div>

                  <div class="node-line two"></div>

                  <div class="node-plus one">
                    +
                  </div>

                  <div class="node-tag green">
                    Sports
                  </div>

                  <div class="node-tag pink">
                    Education
                  </div>

                </div>

              </div>

            </div>


            <!-- =========================
                 BROWN CARD
            ========================== -->

            <div class="col-md-6">

              <div class="workflow-card workflow-small-card card-brown">

                <h3>
                  Save what inspires you
                </h3>

                <p>
                  Keep your favorite illustrations and collections in one place, so they're easy to find when you need them.
                </p>


                <div class="project-visual">

                  <div class="project-folder">

                    <img
                      class="project-image"
                      src="https://img.illusbook.com/collection/Happy-ganesh-chaturthi-concept-illustration.jpg"
                      alt=""
                    >

                  </div>

                  <div class="project-folder two">

                    <img
                      class="project-image"
                      src="https://img.illusbook.com/collection/Happy-ayudha-pooja-india-festival-concept-illustration.jpg"
                      alt=""
                    >

                  </div>

                </div>

              </div>

            </div>


            <!-- =========================
                 BLUE CARD
            ========================== -->

            <div class="col-md-6">

              <div class="workflow-card workflow-small-card card-green-dark">

                <h3>
                 Download and create
                </h3>

                <p>
                 Found the right one? Download a ready-to-use illustration and bring it straight into your design workflow.
                </p>


                <!-- <div class="run-app-text">
                  RUN APP
                </div> -->

                <img
                  class="basketball-image"
                  src="https://img.illusbook.com/collection/Happy-Children-Playing-in-Winter-Snow.jpg"
                  alt=""
                >

              </div>

            </div>

          </div>

        </div>

      </div>

    </div>

  </div>

</section>

<section class="illusbook-workflow">

  <div class="container-fluid">

    <!-- Main content -->
    <div class="workflow-content">

      <!-- Eyebrow -->
      <span class="workflow-eyebrow">
        Your creative workflow
      </span>

      <!-- Heading -->
      <h2>
        Illustrations that fit<br>
        your workflow.
      </h2>

      <!-- Description -->
      <p class="text-secondary">
        Download the right visual and take it wherever you create 
        from Figma and Illustrator to Canva, websites, presentations,
        and more.
      </p>

      <!-- CTA -->
      <a routerLink="illustration-collection/people-illustrations" class="workflow-button">
        Explore illustrations
        <span>→</span>
      </a>

    </div>


    <!-- Logo Marquee -->
    <div class="workflow-marquee">

      <div class="workflow-track">


        <!-- Logo 2 -->
        <div class="workflow-brand">
          <img
            src="../../../../assets/img/adobe.svg"
            alt="Adobe Illustrator"
          >
          <span>Illustrator</span>
        </div>

        <!-- Logo 3 -->
        <div class="workflow-brand">
          <img
            src="../../../../assets/img/canva.webp"
            alt="Canva"
          >
          <span>Canva</span>
        </div>

        <!-- Logo 4 -->
        <div class="workflow-brand">
          <img
            src="../../../../assets/img/framer.svg"
            alt="Framer"
          >
          <span>Framer</span>
        </div>

        <!-- Logo 5 -->
        <div class="workflow-brand">
          <img
            src="../../../../assets/img/webflow.svg"
            alt="Webflow"
          >
          <span>Webflow</span>
        </div>


        <!-- Logo 1 -->
        <div class="workflow-brand">
          <img
            src="../../../../assets/img/figma.svg"
            alt="Figma"
          >
          <span>Figma</span>
        </div>

        <!-- Logo 7 -->
        <div class="workflow-brand">
          <img
            src="../../../../assets/img/ps.svg"
            alt="Photoshop"
          >
          <span>Photoshop</span>
        </div>


        <!-- Duplicate logos for seamless animation -->

        <div class="workflow-brand">
          <img
            src="../../../../assets/img/adobe.svg"
            alt=""
          >
          <span>Illustrator</span>
        </div>

        <div class="workflow-brand">
          <img
            src="../../../../assets/img/canva.webp"
            alt=""
          >
          <span>Canva</span>
        </div>

        <div class="workflow-brand">
          <img
            src="../../../../assets/img/framer.svg"
            alt=""
          >
          <span>Framer</span>
        </div>

        <div class="workflow-brand">
          <img
            src="../../../../assets/img/webflow.svg"
            alt=""
          >
          <span>Webflow</span>
        </div>


        <div class="workflow-brand">
          <img
            src="../../../../assets/img/figma.svg"
            alt=""
          >
          <span>Figma</span>
        </div>

        <div class="workflow-brand">
          <img
            src="../../../../assets/img/ps.svg"
            alt=""
          >
          <span>Photoshop</span>
        </div>

      </div>

    </div>

  </div>

</section>

<section class="illusbook-usecases">
  <div class="container">

    <!-- Section Header -->
    <div class="usecases-header">
      <div>
        <h2>From idea to beautiful visual</h2>

        <p class="text-secondary">
          Ready-to-use illustrations for websites, apps, presentations,
          marketing, and everything you create.
        </p>
      </div>

      <a routerLink="illustration-collection/education-illustrations" class="usecases-btn">
        Explore illustrations <span>→</span>
      </a>
    </div>


    <!-- Cards -->
    <div class="row g-3">

      <!-- Card 1 -->
      <div class="col-lg-4 col-md-6">

        <a routerLink="illustration-collection/business-illustrations" class="usecase-card">

          <img
            src="../../../../assets/img/websites_landingpages.png"
            alt="Website illustrations"
          >

          <div class="usecase-overlay"></div>

          <div class="usecase-content">
            <h3>Websites & landing pages</h3>

            <p>
              Make your pages more engaging with illustrations
              designed to communicate ideas beautifully.
            </p>
          </div>

        </a>

      </div>


      <!-- Card 2 -->
      <div class="col-lg-4 col-md-6">

        <a routerLink="illustration-collection/people-illustrations" class="usecase-card">

          <img
            src="../../../../assets/img/mobile_apps.png"
            alt="App illustrations"
          >

          <div class="usecase-overlay"></div>

          <div class="usecase-content">
            <h3>Apps & products</h3>

            <p>
              Create memorable onboarding, empty states,
              feature pages, and product experiences.
            </p>
          </div>

        </a>

      </div>


      <!-- Card 3 -->
      <div class="col-lg-4 col-md-6">

        <a routerLink="illustration-collection/education-illustrations" class="usecase-card">

          <img
            src="../../../../assets/img/presentations.png"
            alt="Presentation illustrations"
          >

          <div class="usecase-overlay"></div>

          <div class="usecase-content">
            <h3>Presentations & content</h3>

            <p>
              Turn ideas into visual stories that make
              presentations and content more memorable.
            </p>
          </div>

        </a>

      </div>


      <!-- Full Width Card -->
      <div class="col-12">

        <a routerLink="illustration-collection/christmas-illustrations" class="usecase-card usecase-card-wide">

          <img
            src="../../../../assets/img/social_campign.png"
            alt="Marketing illustrations"
          >

          <div class="usecase-overlay"></div>

          <div class="usecase-content">

            <h3>Marketing & social media</h3>

            <p>
              Bring campaigns, social posts, blogs, emails,
              and marketing content to life with the right illustration.
            </p>

          </div>

        </a>

      </div>

    </div>

  </div>
</section>




<section class="illusbook-features">
  <div class="container">

    <div class="features-wrapper">

      <!-- Header -->
      <div class="features-header">
        <h2>Everything you need to create with illustrations</h2>

        <p>
          Discover, organize, customize, and download beautiful illustrations
          for every project.
        </p>
      </div>


      <!-- Features -->
      <div class="row features-grid">

        <!-- Feature 1 -->
        <div class="col-lg-4 col-md-6">
          <div class="feature-item">

            <div class="feature-icon">
              <svg viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 3L14.5 9.5L21 12L14.5 14.5L12 21L9.5 14.5L3 12L9.5 9.5L12 3Z"
                  stroke="currentColor"
                  stroke-width="1.8"
                  stroke-linejoin="round"
                />
              </svg>
            </div>

            <div>
              <h3>Curated illustration library</h3>

              <p>
                Explore a growing collection of beautiful illustrations
                across styles, categories, and themes.
              </p>
            </div>

          </div>
        </div>


        <!-- Feature 2 -->
        <div class="col-lg-4 col-md-6">
          <div class="feature-item">

            <div class="feature-icon">
              <svg viewBox="0 0 24 24" fill="none">
                <rect
                  x="4"
                  y="4"
                  width="16"
                  height="16"
                  rx="3"
                  stroke="currentColor"
                  stroke-width="1.8"
                />

                <path
                  d="M8 12L11 15L16 9"
                  stroke="currentColor"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>

            <div>
              <h3>Ready to use</h3>

              <p>
                Find the right visual and download it for your website,
                app, presentation, marketing, or content.
              </p>
            </div>

          </div>
        </div>


        <!-- Feature 3 -->
        <div class="col-lg-4 col-md-6">
          <div class="feature-item">

            <div class="feature-icon">
              <svg viewBox="0 0 24 24" fill="none">
                <path
                  d="M6 3H15L19 7V21H6V3Z"
                  stroke="currentColor"
                  stroke-width="1.8"
                  stroke-linejoin="round"
                />

                <path
                  d="M14 3V8H19"
                  stroke="currentColor"
                  stroke-width="1.8"
                />

                <path
                  d="M9 13H16M9 17H14"
                  stroke="currentColor"
                  stroke-width="1.8"
                  stroke-linecap="round"
                />
              </svg>
            </div>

            <div>
              <h3> PNG, SVG, EPS, & AI</h3>

              <p>
                Download high-quality assets in formats that fit
                your design workflow.
              </p>
            </div>

          </div>
        </div>


        <!-- Feature 4 -->
        <div class="col-lg-4 col-md-6">
          <div class="feature-item">

            <div class="feature-icon">
              <svg viewBox="0 0 24 24" fill="none">
                <path
                  d="M4 7H20"
                  stroke="currentColor"
                  stroke-width="1.8"
                  stroke-linecap="round"
                />

                <path
                  d="M4 12H20"
                  stroke="currentColor"
                  stroke-width="1.8"
                  stroke-linecap="round"
                />

                <path
                  d="M4 17H20"
                  stroke="currentColor"
                  stroke-width="1.8"
                  stroke-linecap="round"
                />

                <circle
                  cx="8"
                  cy="7"
                  r="2"
                  fill="#1f1f1f"
                  stroke="currentColor"
                  stroke-width="1.5"
                />

                <circle
                  cx="15"
                  cy="12"
                  r="2"
                  fill="#1f1f1f"
                  stroke="currentColor"
                  stroke-width="1.5"
                />

                <circle
                  cx="11"
                  cy="17"
                  r="2"
                  fill="#1f1f1f"
                  stroke="currentColor"
                  stroke-width="1.5"
                />
              </svg>
            </div>

            <div>
              <h3>Collections & organization</h3>

              <p>
                Save your favorite illustrations and organize
                inspiration into collections for easy access.
              </p>
            </div>

          </div>
        </div>


        <!-- Feature 5 -->
        <div class="col-lg-4 col-md-6">
          <div class="feature-item">

            <div class="feature-icon">
              <svg viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 3L19 6V11C19 15.5 16.1 19.1 12 21C7.9 19.1 5 15.5 5 11V6L12 3Z"
                  stroke="currentColor"
                  stroke-width="1.8"
                  stroke-linejoin="round"
                />

                <path
                  d="M9 12L11 14L15 10"
                  stroke="currentColor"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>

            <div>
              <h3>Clear licensing</h3>

              <p>
                Understand how you can use each illustration
                with straightforward licensing information.
              </p>
            </div>

          </div>
        </div>


        <!-- Feature 6 -->
        <div class="col-lg-4 col-md-6">
          <div class="feature-item">

            <div class="feature-icon">
              <svg viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 3V21"
                  stroke="currentColor"
                  stroke-width="1.8"
                  stroke-linecap="round"
                />

                <path
                  d="M17 7C17 5.9 15.2 5 12.5 5C9.8 5 8 6.1 8 7.5C8 9.2 10.1 9.8 12.5 10.5C14.9 11.2 17 11.8 17 13.5C17 15 15.2 16 12.5 16C9.8 16 8 15.1 8 14"
                  stroke="currentColor"
                  stroke-width="1.8"
                  stroke-linecap="round"
                />
              </svg>
            </div>

            <div>
              <h3>Free to start</h3>

              <p>
                Get started with free daily downloads or unlock
                more with Illusbook Pro.
              </p>
            </div>

          </div>
        </div>

      </div>

    </div>

  </div>
</section>





<section class="py-5">
  <div class="container">

    <div class="row">
      <div class="col-md-3">
        <h3 class="fw-bold mb-4">Answers to your top questions</h3>
      </div>

      <div class="col-md-9">
        <div class="accordion mb-5" id="accordionExample">
          <div class="accordion-item mb-4">
            <h2 class="accordion-header">
              <button class="accordion-button fs-5 collapsed" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
             What is Illusbook?
              </button>
            </h2>
            <div id="collapseOne" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
              <div class="accordion-body text-secondary">
              Illusbook is an illustration library where you can discover beautiful, ready-to-use illustrations for websites, apps, presentations, marketing, and more.
              </div>
            </div>
          </div>
          <div class="accordion-item mb-3">
            <h2 class="accordion-header">
              <button class="accordion-button fs-5 collapsed" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
               Can I use Illusbook illustrations for commercial projects?
              </button>
            </h2>
            <div id="collapseTwo" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
              <div class="accordion-body text-secondary">
               Yes, depending on the illustration and your plan. Always check the license before using an asset for commercial purposes.
              </div>
            </div>
          </div>
          <div class="accordion-item mb-3">
            <h2 class="accordion-header">
              <button class="accordion-button fs-5 collapsed" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
               Can I customize the illustrations?
              </button>
            </h2>
            <div id="collapseThree" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
              <div class="accordion-body text-secondary">
               Yes, for illustrations that support customization, you can modify them to better match your brand, project, or visual style.
              </div>
            </div>
          </div>
          <div class="accordion-item mb-3">
            <h2 class="accordion-header">
              <button class="accordion-button fs-5 collapsed" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
               What formats can I download?
              </button>
            </h2>
            <div id="collapseFour" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
              <div class="accordion-body text-secondary">
              Illustrations are available in commonly used formats such as PNG, SVG, EPS, and AI, depending on the asset.
              </div>
            </div>
          </div>

          <div class="accordion-item mb-3">
            <h2 class="accordion-header">
              <button class="accordion-button fs-5 collapsed" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
               Is Illusbook free to use?
              </button>
            </h2>
            <div id="collapseFive" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
              <div class="accordion-body text-secondary">
               Yes. You can start with free illustrations and limited daily downloads. Illusbook Pro provides access to more content and additional benefits.
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>


  </div>
</section>